import * as serviceEndpoints from "../../config/serviceEndPoints";
import { fcaFastApi } from "../../services/authorizationService";

// Presence lives only in fca-pybackend (FCA-6979) — there is no Ruby/Django
// equivalent to fall back to, so these call `fcaFastApi` directly rather than
// choosing a gateway behind a migration flag. Visibility of the feature is
// gated by the `active_sessions_page` FME flag at the call sites instead.

export const sendSessionHeartbeat = (payload = {}) => fcaFastApi.post(serviceEndpoints.activeSessionsEndPoints.heartbeat, payload);

export const getActiveSessions = (params = {}) => fcaFastApi.get(serviceEndpoints.activeSessionsEndPoints.list, { params });
